import Link from 'next/link'
import { cn } from '@/lib/utils'

interface LogoMarkProps {
    className?: string
}

/** The Verdane leaf V mark. */
export const LogoMark = ({ className }: LogoMarkProps) => {
    return (
        <span aria-hidden='true' className={cn('relative inline-block size-6 shrink-0 overflow-hidden rounded-full', className)}>
            <img src='/images/uploads/logo.png' alt='' className='absolute inset-0 size-full scale-[1.36] object-cover' />
        </span>
    )
}

interface LogoProps {
    className?: string
    href?: string
    onClick?: () => void
}

export const Logo = ({ className, href = '/', onClick }: LogoProps) => {
    return (
        <Link
            href={href}
            onClick={onClick}
            aria-label='Verdane home'
            className={cn('group inline-flex items-center gap-2.5 text-cream', className)}
        >
            <LogoMark className='size-[22px]' />

            <span className='text-[17px] font-medium tracking-[-0.04em]'>
                Verdane
            </span>
        </Link>
    )
}
